import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/.pnpm/next@15.5.19_@babel+core@7.29.7_@playwright+test@1.60.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["NavProgressProvider"] */ "/vercel/path0/frontend/src/components/nav/nav-progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TermsReacceptanceModal"] */ "/vercel/path0/frontend/src/components/terms/terms-reacceptance-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoBanner"] */ "/vercel/path0/frontend/src/components/ui/demo-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/frontend/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/frontend/src/lib/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrganizationProvider"] */ "/vercel/path0/frontend/src/lib/contexts/OrganizationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PermissionProvider"] */ "/vercel/path0/frontend/src/lib/contexts/PermissionContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TokenProvider"] */ "/vercel/path0/frontend/src/lib/contexts/TokenContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/vercel/path0/frontend/src/lib/contexts/UserContext.tsx");
